
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#3887FF","d":"M8 13.267L3.056 16 4 10.211l-4-4.1 5.528-.844L8 0z"}}),_c('path',{attrs:{"stroke":"#3887FF","d":"M12.285 15.064l-.82-5.021 3.498-3.584-4.83-.738L8 1.177 5.867 5.72l-4.83.738 3.497 3.584-.819 5.021L8 12.696l4.285 2.368z"}})])])
      }
    
      }
    